import { IconButton, InputAdornment, TextField } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import SearchIcon from '@mui/icons-material/Search';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useCallback, useMemo } from 'react';

const useStyles = makeStyles((theme) => ({
    searchRoot: {
        "& .MuiInputBase-input": {
            width: "100%",
        },
        "&:focus-within, & .Mui-focused, &:hover": {
            "& $submitButton": {
                opacity: 1,
                pointerEvents: "initial",
            },
        },
    },
    searchTextBox: {
        width: "100%",
    },
    searchIcon: {
        fill: theme.palette.secondary.muted,
    },
    submitButton: {
        opacity: 0,
        pointerEvents: "none",
        borderRadius: 0,
    },
}));

export default function SearchBox({ onInput = null, onSubmit = null, onBlur = null, value = "", placeholder = "Search...", rootClassName = null, inputClassName = null }) {
    const classes = useStyles();

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        onSubmit?.(e.currentTarget.searchQuery.value);
    }, [onSubmit]);

    const handleInput = useCallback((e) => {
        // call passed in callback
        onInput?.(e.target.value);
    }, [onInput]);

    const handleBlur = useCallback((e) => {
        onBlur?.(e.target.value);
    }, [onBlur]);

    const inputProps = useMemo(() => ({
        name: "searchQuery",
        onChange: handleInput,
        onBlur: handleBlur,
        className: ["SearchBox-input", classes.searchTextBox, inputClassName].join(" "),
        startAdornment: (
            <InputAdornment position="start">
                <SearchIcon className={classes.searchIcon} />
            </InputAdornment>
        ),
        endAdornment: (
            <InputAdornment position="end">
                <IconButton type="submit" className={classes.submitButton} size="large">
                    <ArrowForwardIcon className={classes.submitIcon} />
                </IconButton>
            </InputAdornment>
        ),
    }), [classes.searchIcon, classes.searchTextBox, classes.submitButton, classes.submitIcon, handleBlur, handleInput, inputClassName]);
    
    return (
        <>
            <form className={["SearchBox-form", classes.searchRoot, rootClassName].join(" ")} onSubmit={handleSubmit}>
                <TextField placeholder={placeholder} variant="standard"
                    defaultValue={value} InputProps={inputProps} />
            </form>
        </>
    );
}
